exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".client-users-container {\n  padding: 2px;\n  margin: 2px;\n  margin-top: 20px;\n  height: calc(100vh - 200px); }\n  .client-users-container .table-box {\n    overflow: auto;\n    max-height: calc(100vh - 290px); }\n  .client-users-container ::-webkit-scrollbar-thumb {\n    background-color: silver; }\n  .client-users-container ::-webkit-scrollbar {\n    width: 7x;\n    height: 7px; }\n\n@media screen and (max-width: 600px) {\n  .client-users-container {\n    margin: 20px auto 0;\n    width: calc(100vw - 20px); }\n    .client-users-container .custom-table {\n      padding: 2px !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/users/index.scss
// module id = 1205
// module chunks = 0